<template>
    <div>
        <div class="columns">
            <div class="column">
                <form-input name="content" v-model="question.content" :error="errors.content" holder="Contenido" label="Contenido" type="text" ></form-input>
                <form-input name="order" v-model="question.order" :error="errors.order" holder="Orden" label="Orden" type="number" ></form-input>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Form",
        props:{
            question: {
                required: true,
                type: Object,
            },
            errors: {
                required: true,
                type: Object,
            },
        }
    }
</script>

<style scoped>

</style>